import { usePortalStore } from "src/frontend/components/Shared/Portals/State/portalStore"

export function useDeleteComponentAnimation(componentId?: string) {
  return usePortalStore((state) =>
    !componentId || state.deleteComponentAnimation?.componentId === componentId
      ? state.deleteComponentAnimation
      : undefined
  )
}
